import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';

@Injectable()
export class HttpClientCustom {
  public httpClient: any;
  public activeToken: any;
  constructor(public http: HttpClient, public router: Router, public _toaster: ToasterComponent) {
    this.httpClient = http;
  }

  public get(url: string, options?: any): Observable<any> {
    return this.http.get(url, options);
  }

  public getBlob(url: string, options?: any): Observable<any> {
    options = {};
    options.responseType = "blob";
    options.observe = 'response';
    return this.http.get<HttpResponse<Blob>>(url, options);
  }
  
  public postBlob(url: string,data: any,options?: any): Observable<any> {
    console.log("called POst Blob");
    options = {};
    options.responseType = "blob";
    options.observe = 'response';
    return this.http.post<HttpResponse<Blob>>(url, data,options);
  }

  public filePost(url: string, data: any, options?: any): Observable<any> {
    options = {};
    options = { headers: new HttpHeaders() };
    options.headers.append('Content-Type', 'multipart/form-data');
    options.responseType = 'text';
    return this.http.post(url, data, options);
  }
  public filePostString(url: string, data: any, options?: any): Observable<any> {
    options = {};
    options = { headers: new HttpHeaders() };
    options.headers.append('Content-Type', 'multipart/form-data');
    return this.http.post(url, data, options);
  }
  public post(url: string, data: any, options?: any): Observable<any> {
    return this.http.post(url, data, options);
  }

  public put(url: string, data: any, options?: any): Observable<any> {
    return this.http.put(url, data, options);
  }

  public delete(url: string, options?: any): Observable<any> {
    return this.http.delete(url, options);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/http.client.ts